'use strict';

var PubSub = require('tscom-pubsub');

var UserView = require('standard-vote/app/scripts/views/user');

module.exports = UserView.extend({

    logout: function (e) {

        e.preventDefault();

        this.auth.deAuthorize();

        var evt = {
            category: 'Button Click',
            action: 'Button Click: Logout',
            label: 'Button Click: Logout'
        };

        PubSub.trigger('clearUser');
        PubSub.trigger('trackGoogle',evt);
    }
});



// WEBPACK FOOTER //
// ./app/scripts/views/user.js